export default {
    personnelList: [
        {
          name: '人才甄选',
          desc: 'APJ具备科学的人才甄选体系，通过知识、技术、个性特征、职业素养等方面综合考查,使“人尽其才，才尽其用，才职相称"，实现人岗匹配',
          icon: 'iconsousuo'
        }, {
          name: '人オ培养',
          desc: 'APJ具备成熟的组织级及项目级双层次培训体系，打造了强大的培训讲师队伍，提升员工的工作能力与职业素养',
          icon: 'iconshuju'
        }, {
          name: '人才晋升',
          desc: 'APJ具备开放、公正、合理的晋升平台，按照岗位的分工定位及任职能力的不同，建立了合理的职位等级体系，同时为每个岗位提供了相应的发展和晋升空间，实现员工的晋升',
          icon: 'iconshangzhang'
        }, {
          name: '人才发展',
          desc: 'APJ将为优秀员工提供"双通道"的发展路径，员工可根据个人的工作性质、能力特长、性格特点、职业规划等因素选择向管理、技术两个方向发展',
          icon: 'iconshunxupaidui'
        }
      ],
    recruitList: [
        {
            name: '.NET（初级/中级/高级）',
            type: '社会招聘',
            requirement1: {
            name: '岗位职责：',
            content: [
                '参与.NET项目相应的需求讨论、项目设计、代码编写、文档编写、单元测试等工作。'
            ]
            },
            requirement2: {
            name: '岗位要求：',
            content: [
                '（1） 大专（含）以上学历，计算机相关专业，1年以上相关项目经验；',
                '（2） 熟悉WEB项目开发，掌握Ajax，HTML，CSS，XML，JavaScript，了解jQuery；',
                '（3） 熟悉Visual Studio开发环境，掌握ASP.NET/C#,或VB.NET；',
                '（4） 熟悉MS SQL Server开发或设计，熟悉存储过程、触发器。'
            ]
            }
        }, {
            name: 'SharePoint开发工程师',
            type: '社会招聘',
            requirement1: {
            name: '岗位职责：',
            content: [
                '负责SharePoint核心项目的开发和维护，如企业项目管理系统。'
            ]
            },
            requirement2: {
            name: '岗位要求：',
            content: [
                '（1） 大专（含）以上学历，计算机相关专业，2年以上ASP.NET项目开发经验；',
                '（2） 熟悉WEB项目开发，掌握Ajax，HTML，CSS，XML，JavaScript，了解jQuery；',
                '（3） 熟悉Visual Studio开发环境，掌握ASP.NET/C#,或VB.NET；',
                '（4） 熟悉MS SQL Server开发或设计，熟悉存储过程、触发器；',
                '（5）还应了解过SharePoint开发机制，乐于/善于学习新技术；',
                '（6） 工作责任心强，具备良好的团队合作精神，较强的沟通、协作能力。'
            ]
            }
        }, {
            name: 'Java（初级/中级/高级）',
            type: '社会招聘',
            requirement1: {
            name: '岗位职责：',
            content: [
                '参与Java项目相应的需求讨论、项目设计、代码编写、文档编写、单元测试等工作。'
            ]
            },
            requirement2: {
            name: '岗位要求：',
            content: [
                '（1） 大专（含）以上学历，计算机相关专业，1年以上相关项目经验；',
                '（2） 熟悉WEB项目开发，掌握Ajax，HTML，CSS，XML，JavaScript，了解jQuery；',
                '（3） 掌握J2EE相关技术，如SERVLET/JSP/JMS/JTA；',
                '（4） 熟悉spring、struts、ORMAPPING框架（Hibernate或IBATIS）；',
                '（5） 熟悉ORACLE，熟悉PL/ SQL开发；',
                '（6） 熟悉主流的J2EE应用服务器，如Weblogic、Websphere等；',
                '（7） 工作责任心强，具备良好的团队合作精神，较强的沟通、协作能力。'
            ]
            }
        }, {
            name: '软件测试工程师（初级/中级/高级）',
            type: '社会招聘',
            requirement1: {
            name: '岗位职责：',
            content: [
                '（1） 搭建测试环境，编写测试计划；',
                '（2） 执行产品的功能、性能及其他方面的测试；',
                '（3） 对测试发现的问题进行跟踪，编写测试报告。'
            ]
            },
            requirement2: {
            name: '岗位要求：',
            content: [
                '（1） 大专（含）以上学历，1年以上软件测试经验；',
                '（2） 熟悉软件测试方法和流程，了解SQL script, VBScript, Browser and Database的相关知识；',
                '（3） 具备一定的缺陷管理意识，严谨的工作习惯；',
                '（4） 较好的文档编写能力，熟悉测试用例、测试报告的编写；',
                '（5） 较强的逻辑分析能力和学习能力，具备较强的总结能力；',
                '（6） 有性能测试和安全测试的经验者优先，了解使用QTP, MS VSTS等测试工具者优先。'
            ]
            }
        }, {
            type: '校园招聘',
            requirement1: {
            name: '拟分配职位：',
            content: [
                '.NET开发、JAVA开发、软件测试等方向'
            ]
            },
            requirement2: {
            name: '基本要求：',
            content: [
                '（1） 本科（含）以上学历，计算机相关专业；',
                '（2） 有志于投身于软件开发或测试职业；',
                '（3） 踏实好学，能承接一定的工作压力；',
                '（4） 具备相应职位的基本理论知识，有项目实践经验者优先。',
                '更多资讯，请关注APJ微信服务号 或 “前程无忧”！',
                '更多职位：请在前程无忧搜索“爱浦京”',
                '简历投递，请发送至：HR@apjcorp.com'
            ]
            }
        }
    ],
    recruitPosition: [
        // '.NET (初级/中级/高级)',
        // 'SharePoint开发工程师',
        // 'Java (初级/中级/高级)',
        // '软件测试工程师 (初级/中级/高级)',
        // '优秀应届毕业生 (.NET开发、Java开发、 软件测试等方向)'
        '架构师(银行技术架构方向)',
        'AI Platform Lead（银行方向）',
        'AI Platform Engineer（银行方向）',
        'R&D Lead（银行方向）',
        'DevOps 工程师（银行方向）',
        '中心经理（银行方向）',
        '高级.NET开发工程师',
        '全栈工程师',
        '销售经理'
    ],
    recruitFeature: [
        {
            name: '【工作地点】',
            title: '珠海、广州、长沙'
        }, {
            name: '【更多资讯】',
            title: '请关注APJ微信服务号或“前程无忧”!'
        }, {
            name: '【更多职位】',
            title: '请在前程无忧搜索“爱浦京"'
        }, {
            name: '【简历投递】',
            title: '请发送至: HR@apjcorp.com'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/views/aboutus/join/data.js